import { TGetCommonDocumentParams } from '@/services';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IPayloadGetDefineDocumentUploadListSuccess,
	TDefineDocumentUploadListStore,
	TPayloadGetDefineDocumentUploadListRequest,
	TPayloadUpdateDocumentRequest,
} from './define-document-upload.type';

const initialState = {
	fetching: false,
	defineDocumentUploadList: [] as TDefineDocumentUploadListStore,
	defineDocumentUploadListFull: [] as TDefineDocumentUploadListStore,
	params: {} as TGetCommonDocumentParams,
	total: 0,
};

const defineDocumentUploadSlice = createSlice({
	initialState,
	name: 'defineDocumentUpload',
	reducers: {
		/**---- GET DEFINE_DOCUMENT_UPLOAD LIST START ---- */
		getDefineDocumentUploadListRequest: (
			state,
			action: PayloadAction<TPayloadGetDefineDocumentUploadListRequest>
		) => {
			state.fetching = true;
			state.params = action.payload;
		},
		getDefineDocumentUploadListSuccess: (
			state,
			action: PayloadAction<IPayloadGetDefineDocumentUploadListSuccess>
		) => {
			const { defineDocumentUploadList } = action.payload;
			state.fetching = false;
			state.defineDocumentUploadList = defineDocumentUploadList;
		},
		getDefineDocumentUploadListFailure: (state) => {
			state.fetching = false;
		},
		setDefineDocumentUploadListFull: (
			state,
			action: PayloadAction<IPayloadGetDefineDocumentUploadListSuccess>
		) => {
			const { defineDocumentUploadList } = action.payload;
			state.defineDocumentUploadListFull = defineDocumentUploadList;
		},
		getDefineDocumentUploadListFull: (
			state,
			action: PayloadAction<IPayloadGetDefineDocumentUploadListSuccess>
		) => {
			const { defineDocumentUploadList } = action.payload;
			state.fetching = false;
			state.defineDocumentUploadListFull = defineDocumentUploadList;
		},
		clearDefineDocumentUploadList: (state) => {
			state.defineDocumentUploadList = [];
			state.defineDocumentUploadListFull = [];
		},
		/**---- GET DEFINE_DOCUMENT_AREA LIST END ---- */

		updateDocumentRequest: (
			state,
			action: PayloadAction<TPayloadUpdateDocumentRequest>
		) => {
			state.fetching = true;
		},
		updateDocumentSuccess: (state) => {
			state.fetching = false;
		},
		updateDocumentFailure: (state) => {
			state.fetching = false;
		},
	},
});

export const DefineDocumentUploadSelectors = {
	selectFetching: (state: RootState) => state.defineDocumentUpload.fetching,
	selectDefineDocumentUploadList: (state: RootState) =>
		state.defineDocumentUpload.defineDocumentUploadList,
	selectDefineDocumentUploadListFull: (state: RootState) =>
		state.defineDocumentUpload.defineDocumentUploadListFull,
	selectParams: (state: RootState) => state.defineDocumentUpload.params,
	selectTotal: (state: RootState) => state.defineDocumentUpload.total,
};

export const DefineDocumentUploadActions = defineDocumentUploadSlice.actions;
export const DefineDocumentUploadReducer = defineDocumentUploadSlice.reducer;
